/*** IMPORTS FROM imports-loader ***/
var define = false;

export default { required: true, message: 'Please specify' }

